import request from '../../axios';

export const getAStoreAds = async (params: IGetAStoreAdsPayload) => {
  const {data}: {data: IGetAStoreAdsResponse} = await request.get(
    `/api/v2/store/store-ads`,
    {
      params,
    },
  );

  return data;
};
